import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle, } from "../../../../components/BladeHeader";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  ${BladeContent} {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &.has-backdrop {
      min-height: calc(440px - ${chroma.spacers.variable.xxl});

      ${chroma.mediaQueries.desktopUp} {
        min-height: calc(640px - ${chroma.spacers.variable.xxl});
      }
    }

    .ctaContainer {
      justify-content: center;
      display: flex;
      flex: 1;
      flex-direction: row;
      gap: ${chroma.spacers.variable.m};
      align-items: start;

      &.solo-cta {
        align-items: center;
      }
    }
  }

  ${BladeHeader} {
    text-align: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    width: 1056px;

    ${chroma.mediaQueries.tabletDown} {
      width: 100%;
    }
  }

  ${BladeContent}.has-backdrop > ${BladeHeader},
  ${BladeContent}.has-links > ${BladeHeader} {
    padding-bottom: ${chroma.spacers.variable.xl};
  }

  ${BladeHeaderBody} {
    ${chroma.typography.body3}
    max-width:  calc(960px - ${chroma.spacers.variable.xl});
    margin-top: ${chroma.spacers.variable.xxs};
    width: 784px;

    ${chroma.mediaQueries.tabletDown} {
      width: 100%;
    }
  }

  ${BladeHeaderSupertitle} {
    ${chroma.typography.body2}
    ${textUppercaseMixin}
    padding-bottom: ${chroma.spacers.variable.xs};
  }

  ${BladeHeaderTitle} h1 {
    ${chroma.typography.display3}
    padding-bottom: ${chroma.spacers.variable.sm};
  }
`;
//# sourceMappingURL=index.js.map